import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage1Varuosad from "./pages/Webpage1Varuosad";
import Webpage2K__psised from "./pages/Webpage2K__psised";
import Webpage3Lehte_ei_leitud from "./pages/Webpage3Lehte_ei_leitud";
import Webpage4Tellimus from "./pages/Webpage4Tellimus";
import Webpage5Toode from "./pages/Webpage5Toode";

var baseURL = 'https://laitserallypark.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI3IiwianRpIjoiZDMyZWQyYzhkMDRlNDEwNzZkYjQyNGEwNzEzNGVlMWM1NTg3NDU3MTI5N2IxMzc2ZjIwZjZjZWJmY2Q1ZmMwZmRhODk2MWZmZDI5YzI4NGQiLCJpYXQiOjE3ODQ0NDE3MzAuNjk2MTE2LCJuYmYiOjE3ODQ0NDE3MzAuNjk2MTIsImV4cCI6MTc4NDUyODEzMC42OTMwOTYsInN1YiI6IjgiLCJzY29wZXMiOltdfQ.ieSfl8D1NyQIm_R8SuYwX8uHvD7bGCRjgbrYx4jAAE4oZ5GA9s4BPIyjS5OnAqXFj7MHLIfg4aPpgI8XUm_dRTYJdgUQnSof3ZxUwzNmIzIHDsaFNngSQhvLqXUFeYLGJNhRryrx4M3Byibs-O-2rwHzm6jP5kt812R24G_V5rqKsuEQn5AgcHVBBV1ZmpeckKsEwEH21U83UNC81tpEAPLfBRJa37FGu_B1IUIhV683_BQM83LHSdV41EbK7sGDtxRcpmOEXQzjNGa8nQwZ-jb_jERTLK85msTqbkx1VAjQHMg2ZADk9IJ-EYPD8wSC6S-lPQHKZGTIJdCvAtPtrCGNDb2ClxjwPJCkupmxNR7X8t6vJ13NDMLJlKCTiwHjsstms1xx3-gKJcycs5SSnSkkkIJyhq9xsUM2Tb1g_pbRFGJbKVhHxmVocMhKUS--kQAWJsqYjlXbTqIuTVXZkm6DvCzT-v3ipu2dbkE9f91wzqQ0_GQPspYLfziyZSGU13X-ullDN1odiGn8tChGAvJ90sn7RU0SDB5xnUWU97hv-zLQi837ApVeCePUfblMdd14klRoSnYjsr5VeyoEJEUvSb-3IAH-EPMNeufRtbdMNNaAR06VOycw_qebqshwrBmUniKCVAoryjEzniKdRIHzNH7m7_Bii_rjHY5QkTg',
    'Access-api-key': "eyJpdiI6IkpuRjlXcmNsK3ZnZFdqOWpZaEhpYWc9PSIsInZhbHVlIjoieGplMU5QYnpQdHN2Q3FCWnkvWlVGQT09IiwibWFjIjoiZDUwNWNiYmY0MGI5YTI2YWI3ZTIwZTNkOGFmYzQxNjBkOTE4NDYwNGJjMjYwM2M5Yjc5YTQyODQwOTZkN2Y3ZCIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IjlzYUJRQ0M0eGQyY3BmY09Nc2J6MkE9PSIsInZhbHVlIjoiY3NvUGZmcGpFa1pSekFlSGNJZTB2UT09IiwibWFjIjoiMDQ2ZTNmMTBhNjdlYjcxMGFiZDYzNmRlNmVhMTdlYjI0YmMxZjNlNTRlMjRmYjMzMjUwZDJlMWMzNzE5YjkyMCIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: ""
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage1Varuosad />} exact />;
                                                                    <Route path="/et/kupsised" element={<Webpage2K__psised />} exact />;
                                                                    <Route path="/et/*" element={<Webpage3Lehte_ei_leitud />} exact />;
                                                <Route path="*" element={<Webpage3Lehte_ei_leitud />} exact />;
                                                                    <Route path="/et/tellimus" element={<Webpage4Tellimus />} exact />;
                                                                    <Route path="/et/toode/:uuid" element={<Webpage5Toode />} exact />;
                                                                
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}